import bootstrap from 'bootstrap';
import Alpine from 'alpinejs';
import './commons/axios';
import './commons/sweetalert2';
import './commons/notyf';

window.Alpine = Alpine;
Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
  // Alpine.start();

  global.Livewire.on('notyf', function (data) {
    if ('string' === typeof data) {
      notyf.open({
        type: 'info',
        message: data,
      });
    } else {
      notyf.open(data);
    }
  });
});
